export default {
  app: {
    privacy: {
      policy: 'integritetspolicy',
      expansive: 'Genom att använda Expansive godkänner du Expansives {action}',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Sessionen har gått ut',
    sessionExpiredDescription:
      'Din session har gått ut. Logga in igen för att fortsätta använda applikationen.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Välj språk',
      chooseLanguageDescription:
        'Välj ditt föredragna språk för applikationen. Detta ändrar språk för gränssnitt och innehåll.',
    },
    userSelection: {
      cancel: 'Avbryt',
      createNewUser: 'Deras namn finns inte med',
      newUser: 'Ny användare',
      selectAnExistingUser: 'Välj en befintlig användare',
      selectUserHint: 'Välj en befintlig användare eller skapa en ny för att fortsätta.',
      startTypingToSearch: 'Börja skriva...',
    },
    verification: {
      codeVerification: {
        continue: 'Fortsätt',
        header: 'Ange platsens åtkomstkod',
        invalidCode: 'Ogiltig kod, försök igen.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Fortsätt utan platsverifiering',
        enterSiteAccessCode: 'Ange platsens åtkomstkod',
        locationNotEnabledOrAvailable: 'Varför ser jag detta?',
        notAvailable: {
          description: 'GPS-plats stöds inte på denna enhet.',
          header: 'Plats stöds inte',
        },
        notEnabled: {
          description: 'Platstjänster är inte aktiverade eller behörighet har inte beviljats.',
          header: 'Plats är inte aktiverad',
        },
        notVerified: {
          description: 'GPS indikerar att du inte är på plats.',
          header: 'Plats ej verifierad',
        },
        tryAgain: 'Försök igen',
        unavailable: {
          description: 'Vi kunde inte verifiera din GPS-plats.',
          header: 'Plats ej tillgänglig',
        },
        unknown: {
          description: 'Vi kan inte fastställa din plats.',
          header: 'Okänd plats',
        },
        verified: {
          description: 'GPS indikerar att du är på plats.',
          header: 'Plats verifierad',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Inga tillgångar hittades',
        emptyDescription: 'Det finns inga tillgångar kopplade till denna arbetsorder.',
        warrantyParts: 'Reservdelsgaranti upphör',
        serialNumber: 'Serienummer',
        none: '<ingen>',
      },
      updates: {
        emptyTitle: 'Inga uppdateringar hittades',
        emptyDescription: 'Det finns inga uppdateringar för denna arbetsorder.',
        unknownUser: 'Okänd användare',
        none: 'Ingen',
        addComment: {
          buttonLabel: 'Lägg till kommentar',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Risker',
          no: 'Nej',
          yes: 'Ja',
        },
      },
    },
    attachmentsList: {
      attachments: 'Bilagor',
      documents: 'Dokument',
      siteDocuments: 'Platsdokument',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Risker',
        induction: 'Introduktion',
        safeToProceed: 'Säkert att fortsätta',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Förfallodatum',
        activeSessions: 'Aktiva sessioner',
        activeSessionsDescription:
          'Du är redan incheckad på följande arbetsorder. Du måste checka ut från dessa innan du checkar in på en ny.',
        resumeSession: 'Återuppta',
        startTime: 'Startade',
        unexpectedErrorTitle: 'Oväntat fel',
        unexpectedErrorMessage:
          'Ett oväntat fel inträffade vid skapandet av dina sessioner. Försök igen senare.',
        engineerNotFound: 'Ingenjör hittades inte',
        engineerNotFoundDescription:
          'Ingenjören du försöker checka in finns inte i systemet. Kontakta din administratör.',
      },
      verification: {
        code: {
          description:
            'För att checka in, hämta den 4-siffriga koden från platsansvarig eller kontaktperson.',
        },
        geo: {
          continue: 'Fortsätt',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Hämta åtkomstkoden från platschefen eller angiven kontaktperson för att slutföra ditt besök.',
            checkOut: 'Checka ut',
            completeBeforeLeaving: 'Fyll i följande formulär innan du lämnar.',
            continue: 'Fortsätt',
            noResolutionSelected: 'Välj en lösning innan du fortsätter.',
            quoteRequired: {
              hint: 'Besöket klart, offert kommer',
              label: 'Offert krävs',
            },
            returnVisitRequired: {
              hint: 'Vi kommer tillbaka för att slutföra',
              label: 'Återbesök krävs',
            },
            serviceCompleted: {
              hint: 'Ingen ytterligare åtgärd krävs',
              label: 'Service slutförd',
            },
            uploadCheckout: 'Ladda upp en fil, foto eller video',
            visitNotes: 'Besöksanteckningar',
            workOrderResolution: 'Arbetsorderlösning',
            enterNotes: 'Ange eventuella anteckningar här...',
            errors: {
              timedOut: 'Tidsgräns, översteg 30 sekunder. Försök igen.',
              closingSession: 'Fel vid stängning av session',
            },
          },
          success: {
            description:
              'Tack för ditt besök på {site}. | {site} har fortfarande 1 öppen arbetsorder kvar. | {site} har fortfarande {count} öppna arbetsorder kvar.',
            endVisit: 'Avsluta besök',
            header: 'Du har checkat ut',
            viewWorkOrders: 'Checka in på en annan arbetsorder',
          },
          verification: {
            code: {
              description:
                'För att checka ut, hämta den 4-siffriga koden från platsansvarig eller kontaktperson.',
              continue: 'Fortsätt',
            },
            geo: {
              checkOut: 'Checka ut',
              continue: 'Fortsätt',
            },
          },
        },
        detail: {
          assets: 'Tillgångar',
          call: 'Ring',
          checkOut: 'Checka ut',
          closed: 'Stängd',
          details: 'Detaljer',
          dueBy: 'Förfallodatum',
          manageEngineers: 'Hantera ingenjörer',
          notAvailable: 'Ej tillgänglig',
          pointOfContact: 'Kontaktperson',
          siteAccessTimes: 'Platsens öppettider',
          siteAccessInstructions: 'Tillträdesinstruktioner',
          siteAddress: 'Platsadress',
          siteNotes: 'Platsanteckningar',
          siteTelephone: 'Platsens telefon',
          siteLocation: 'Platsens läge',
          updates: 'Uppdateringar',
          more: 'Mer',
          mismatchErrorTitle: 'Fel på arbetsorder',
          mismatchErrorMessage:
            'Arbetsordern du försöker komma åt matchar inte den du är incheckad på. Kontrollera din arbetsorder och försök igen.',
          siteDocuments: 'Platsdokument',
          validFrom: 'Giltig från',
          validUntil: 'Giltig till',
          documentName: 'Dokumentnamn',
          documentType: 'Dokumenttyp',
          attachments: 'Arbetsorderfiler',
          download: 'Ladda ner',
          workDetails: 'Arbetsdetaljer',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Lägg till biträdande ingenjör',
            assistantEngineers: 'Biträdande ingenjörer',
            description: 'Ange namnen på alla ingenjörer på plats av säkerhetsskäl.',
            editMainEngineer: 'Redigera huvudingenjör',
            errors: {
              creatingEngineer: 'Fel vid skapande av ingenjör',
              creatingSession: 'Fel vid skapande av session',
            },
            header: 'Ingenjörer på plats',
            mainEngineer: 'Huvudingenjör',
            newAssistantEngineer: 'Ange deras fullständiga namn',
            next: 'Nästa',
            removeEngineer: 'Ta bort ingenjör',
            selectExistingAssistantEngineer: 'Börja skriva deras namn',
          },
          index: {
            description: 'Ange namnen på alla ingenjörer på plats av säkerhetsskäl.',
            errorCreatingEngineer: 'Fel vid skapande av ingenjör, försök igen.',
            header: 'Ingenjörer på plats',
            hintMainEngineer: 'Ange huvudingenjörens fullständiga namn',
            newMainEngineer: 'Ny huvudingenjör',
            next: 'Nästa',
            selectExistingMainEngineer: 'Välj en befintlig huvudingenjör',
            yes: 'Ja',
            no: 'Nej',
            mainEngineerLabel: 'Är du huvudingenjören?',
          },
        },
        index: {
          callUsOn: 'Ring oss på {phoneNumber}',
          description: 'Hittar du inte det du söker?',
          dueBy: 'Förfallodatum',
          header: 'Välj arbetsorder',
          notAvailable: 'Ej tillgänglig',
          searchWorkOrders: 'Sök arbetsorder...',
        },
        manageEngineers: {
          manageEngineers: 'Hantera ingenjörer',
          notWorking: 'Inaktiva arbetare',
          pause: 'Pausa',
          resume: 'Återuppta',
          workingNow: 'Aktiva arbetare',
          startTime: 'Starttid',
          endTime: 'Sluttid',
          duration: 'Varaktighet',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Feedback',
            feedbackDescription:
              'Lämna feedback på arbetsordern för att hjälpa oss förbättra våra tjänster.',
            feedbackLabel: 'Feedback',
            filesLabel: 'Bilagor',
            submissionLabel: 'Skicka feedback',
          },
          hazards: {
            back: 'Tillbaka',
            hazards: 'Risker',
            next: 'Nästa',
            no: 'Nej',
            noTasksForHazard: 'Det finns inga uppgifter för denna risk.',
            yes: 'Ja',
          },
          induction: {
            continue: 'Fortsätt',
            induction: 'Introduktion',
          },
          index: {
            checkIn: 'Checka in',
            description: 'Fyll i följande riskbedömning för det valda arbetet.',
            fail: 'Misslyckades med att behandla start arbetsorder kontroller.',
            haltMessage:
              'Potentiella risker upptäckta. Avbryt arbetet, granska säkerhetsriktlinjer och kontakta din handledare för vidare instruktioner.',
            header: 'Start arbetsorder kontroller',
            endVisit: 'Avsluta besök',
            leaveFeedback: 'Lämna feedback',
          },
          safeToProceed: {
            continue: 'Fortsätt',
            safeToProceed: 'Säkert att fortsätta',
          },
        },
      },
    },
    index: {
      title: 'Välkommen',
      description: 'Skanna QR-koden på din plats för att börja.',
    },
    login: {
      errorTitle: 'Oväntat fel',
      errorMessage: 'Ett oväntat fel inträffade. Försök skanna QR-koden igen.',
    },
    unauthenticated: {
      welcome: {
        title: 'Välkommen till {site}',
        description:
          'Innan vi kan visa några arbetsorder måste vi verifiera dina uppgifter. Klicka på knappen nedan för att fortsätta.',
        next: 'Fortsätt',
      },
      index: {
        errorTitle: 'Oväntat fel',
        errorMessage: 'Ett oväntat fel inträffade. Försök skanna QR-koden igen.',
      },
      contractor: {
        title: 'Vem arbetar du för?',
        contractor: 'Entreprenör',
        contractorLabel: 'Börja skriva ditt företagsnamn',
        contractorHint: 'Du måste ange minst 3 tecken för att se resultat',
        defaultSelectPlaceholder: '--Vänligen välj--',
        next: 'Nästa',
      },
      user: {
        title: 'Vem är du?',
        cancel: 'Avbryt',
        createNewUserLabel: 'Mitt namn finns inte med',
        existingUserLabel: 'Börja skriva ditt namn',
        existingUserHint: 'Du måste ange minst 3 tecken för att se resultat',
        newUserLabel: 'Ange ditt fullständiga namn',
        next: 'Nästa',
        user: 'Användare',
      },
      verification: {
        methods: {
          add: {
            add: 'Lägg till verifieringsmetod',
            defaultSelectPlaceholder: '--Vänligen välj--',
            emailLabel: 'E-post',
            existingMethodWarning:
              'Du har redan en väntande begäran för denna verifieringsmetod som väntar på admin-godkännande. Att lägga till en ny kommer att skriva över den.',
            method: 'Metod',
            methodLabel: 'Metod',
            mobileCountryHint: 'Välj landskod',
            mobileCountryLabel: 'Mobil landskod',
            mobileHint: 'Ange ditt mobilnummer',
            mobileLabel: 'Mobil',
            title: 'Lägg till verifieringsmetod',
          },
          confirm: {
            confirm: 'Bekräfta',
            description: 'Bekräfta din verifieringsmetod för att fortsätta.',
            label: 'Ange din kod',
            resend: 'Skicka igen',
            resendPrompt: 'Fick du ingen kod?',
            title: 'Bekräfta verifieringsmetod',
          },
          confirmed: {
            description:
              'Du kommer att meddelas när denna verifieringsmetod har godkänts av din admin, och du kan då börja använda den för att verifiera din identitet.',
            forceApproval: 'Tills den är godkänd kan du inte komma åt arbetsorder.',
            nonForceApproval: 'Under tiden kan du fortsätta med begränsad åtkomst.',
            nonForceApprovalButtonLabel: 'Fortsätt med begränsad åtkomst',
            title: 'Väntar på godkännande',
          },
          addNew: 'Lägg till ny verifieringsmetod',
          description:
            'Vi måste verifiera din identitet för att ge dig full åtkomst till arbetsordern.',
          email: 'E-post',
          hint: 'Vi skickar en länk till din valda verifieringsmetod som ger dig full åtkomst till arbetsordern. Om du behöver ändra befintliga verifieringsmetoder, kontakta din administratör.',
          label: 'Välj en verifieringsmetod',
          next: 'Nästa',
          pendingHint: 'Väntar på admin-godkännande',
          sms: 'SMS',
          title: 'Verifiering',
        },
        optional: {
          hint: 'Att verifiera dina användaruppgifter ger dig full åtkomst till arbetsordern',
          label: 'Vill du verifiera dina användaruppgifter?',
          next: 'Nästa',
          no: 'Nej',
          noHint:
            'Jag vill inte verifiera mina användaruppgifter och fortsätta med begränsad åtkomst till arbetsordern',
          title: 'Verifiering',
          yes: 'Ja',
          yesHint:
            'Jag vill verifiera mina användaruppgifter och få full åtkomst till arbetsordern',
        },
        sent: {
          description:
            'En inloggningslänk har skickats till {identifier}. Klicka på länken för att slutföra din inloggning.',
          title: 'Inloggningslänk skickad',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Igår',
      today: 'Idag',
      days: {
        monday: 'Måndag',
        tuesday: 'Tisdag',
        wednesday: 'Onsdag',
        thursday: 'Torsdag',
        friday: 'Fredag',
        saturday: 'Lördag',
        sunday: 'Söndag',
      },
      months: {
        january: 'Januari',
        february: 'Februari',
        march: 'Mars',
        april: 'April',
        may: 'Maj',
        june: 'Juni',
        july: 'Juli',
        august: 'Augusti',
        september: 'September',
        october: 'Oktober',
        november: 'November',
        december: 'December',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Något gick fel',
      message: 'Försök skanna QR-koden igen.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Okänd användare',
      },
      none: 'Ingen',
      types: {
        stateTransition: 'Status ändrad',
        contractorAssigned: 'Entreprenör tilldelad',
        engineerAssigned: 'Ingenjör tilldelad',
        serviceAssigned: 'Tjänst tilldelad',
        priorityChanged: 'Prioritet ändrad',
        actionableDateChanged: 'Åtgärdsdatum ändrat',
        dueDateChanged: 'Förfallodatum ändrat',
        etaDateChanged: 'Beräknad ankomsttid ändrad',
        spendLimitApproved: 'Utgiftsgräns godkänd',
        spendLimitCancelled: 'Begäran om utgiftsgräns avbruten',
        spendLimitRejected: 'Utgiftsgräns nekad',
        spendLimitRequested: 'Utgiftsgräns begärd',
        jobSheetUploaded: 'Arbetsrapport uppladdad',
        slaAlertSent: 'Tidsgräns för SLA överskriden',
        issuedWorkPermit: 'Arbetstillstånd utfärdat',
        requestForServiceSent: 'Tjänsteförfrågan skickad',
        comment: 'Kommentar tillagd',
        unknown: 'Okänd händelse',
      },
      labels: {
        actionableDate: 'Åtgärdsdatum',
        comment: 'Kommentar',
        file: 'Fil',
        contractor: 'Entreprenör',
        dueDate: 'Förfallodatum',
        etaDate: 'Beräknad ankomsttid',
        engineer: 'Ingenjör',
        priority: 'Prioritet',
        requestForService: 'Tjänsteförfrågan',
        service: 'Tjänst',
        spendLimit: 'Utgiftsgräns',
        status: 'Status',
        workPermit: 'Arbetstillstånd',
      },
    },
  },
}
